type CsvCell = string | number | null | undefined;

/**
 * Monta um CSV amigável ao Excel pt-BR: delimitador ";" (padrão da localidade
 * brasileira, não conflita com vírgula decimal), BOM UTF-8 e quebra CRLF.
 * Campos com ";", aspas ou quebra de linha são escapados com aspas duplas.
 */
// Células que começam com estes caracteres são interpretadas como fórmula por
// Excel/Sheets (CSV injection). Prefixamos com aspa simples pra virarem texto.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

export function toCsv(headers: string[], rows: CsvCell[][], delimiter = ";"): string {
  const escape = (value: CsvCell): string => {
    let text = value == null ? "" : String(value);
    if (FORMULA_PREFIX.test(text)) text = "'" + text;
    return new RegExp(`["${delimiter}\\n\\r]`).test(text)
      ? `"${text.replace(/"/g, '""')}"`
      : text;
  };
  const linhas = [headers, ...rows].map((linha) => linha.map(escape).join(delimiter));
  return "﻿" + linhas.join("\r\n");
}

/** Dispara o download de um conteúdo de texto como arquivo. */
export function downloadTextFile(filename: string, content: string, mime = "text/csv;charset=utf-8;") {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
